/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

import env from "../../env";

export const APP_DOMAIN = 'app/App/APP_DOMAIN';
export const REQUEST_DATA = 'app/App/REQUEST_DATA';
export const REQUEST_DATA_RESULT = 'app/App/REQUEST_DATA_RESULT';

export const REQUEST_CREATE = 'app/App/REQUEST_CREATE';
export const REQUEST_CREATE_RESULT = 'app/App/REQUEST_CREATE_RESULT';

export const REQUEST_REGISTER = 'app/App/REQUEST_REGISTER';
export const REQUEST_ACTIVATE = 'app/App/REQUEST_ACTIVATE';

export const REQUEST_USER_INPUT = 'app/App/REQUEST_USER_INPUT';

export const SHOW_MODAL = 'app/App/SHOW_MODAL';

export const UI_TOP_MENU_TOGGLE = 'app/App/UI_TOP_MENU_TOGGLE';

export const API_POST = 'app/App/API_POST';
export const API_GET = 'app/App/API_GET';

export const GET_MY = '/app/App/GET_MY';
export const POST = '/app/App/POST';
export const MY_REQUEST = '/app/App/MY_REQUEST';

export const TOGGLE_FULL_WIDTH = '/app/App/TOGGLE_FULL_WIDTH';
export const LOGOUT = '/app/App/LOGOUT';

export const UI_TOGGLE = '/app/App/UI_TOGGLE';
export const UI_WINDOW_RESIZE = '/app/App/UI_WINDOW_RESIZE';

export const UI_SIDE_NAV_ATTACHED = '/app/App/UI_SIDE_NAV_ATTACHED';
export const UI_SIDE_LIST_ATTACHED = '/app/App/UI_SIDE_LIST_ATTACHED';

export const ACCEPT_COOKIES = '/app/App/ACCEPT_COOKIES';
export const SUBMIT_CONTACT_FORM = '/app/App/SUBMIT_CONTACT_FORM';

export const EXECUTE_CONFIG_COMMANDS = '/app/App/EXECUTE_CONFIG_COMMANDS';

export const FETCH_PUBLIC_CONFIG = '/app/App/FETCH_PUBLIC_CONFIG';

export const LAYOUT_BREAK_SMALL = 800;

export const CHECK_APP_VERSION = '/app/App/CHECK_APP_VERSION';

export const WIENTJES_INSTALATION = {
  APP_CLIENT_ID: 6,
  APP_CLIENT_NAME: 'WIENTJES',

  
};


export const HOOIKAMMER_INSTALLATION = {
  APP_CLIENT_ID: 3,
  APP_CLIENT_NAME: 'WIENTJES',

  
};


export const AUTOHUISSALLAND_INSTALATION = {
  APP_CLIENT_ID: 7,
  APP_CLIENT_NAME: 'AUTOHUISSALLAND',
};